import { useState } from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Switch from "@mui/material/Switch";

// components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Authentication layout components
import IllustrationLayout from "layouts/authentication/components/IllustrationLayout";

// Image
import chat from "assets/images/illustrations/chat.png";
import whiteLogo from "assets/images/illustrations/white_logo.png"
import { AuthService } from "services/authService";
import { useDispatch } from "react-redux";
import { updateUser } from "./../../../../redux/slice/authSlice";

function Illustration() {
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleChangValue = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.email) {
      setErr("Vui lòng nhập số điện thoại hoặc email");
      setTimeout(() => {
        setErr("");
      }, 3000);
      return;
    }
    if (!data.password) {
      setErr("Vui lòng nhập mật khẩu");
      setTimeout(() => {
        setErr("");
      }, 3000);
      return;
    }
    try {
      setLoading(true);
      const { data: result } = await AuthService.login(data);
      if (result && Object.keys(result).length > 0) {
        localStorage.setItem("access_token", result.access_token);
        localStorage.setItem("refresh_token", result.refresh_token);
        const { data: user } = await AuthService.getMe();
        dispatch(updateUser(user));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErr(error?.response?.data?.message || error);
      setTimeout(() => {
        setErr("");
      }, 3000);
    }
  };

  return (
    <IllustrationLayout
      title="Đăng nhập"
      description={
        err ? <p style={{ color: "red" }}>{err}</p> : "Nhập tài khoản và mật khẩu để đăng nhập"
      }
      illustration={{
        image: whiteLogo,
        title: "Buchführung",
        description:
          // "The more effortless the writing looks, the more effort the writer actually put into the process.",
          "Ihre Finanzlage in Echtzeit",
      }}
    >
      <SoftBox component="form" role="form" onSubmit={handleSubmit}>
        <SoftBox mb={2}>
          <SoftInput
            type="text"
            name="email"
            placeholder="Email"
            size="large"
            onChange={handleChangValue}
          />
        </SoftBox>
        <SoftBox mb={1}>
          <SoftInput
            type="password"
            name="password"
            placeholder="Mật khẩu"
            size="large"
            onChange={handleChangValue}
          />
        </SoftBox>
        <SoftBox display="flex" alignItems="center">
          <Link to="/dashboards/forgot-password">
            <SoftTypography
              variant="button"
              fontWeight="regular"
              sx={{ cursor: "pointer", userSelect: "none", color: "#67748e" }}
            >
              Quên mật khẩu ?
            </SoftTypography>
          </Link>
        </SoftBox>
        <SoftBox mt={2} mb={1}>
          <SoftButton onClick={handleSubmit} variant="gradient" color="info" size="large" fullWidth>
            {loading ? "Loading..." : "Đăng Nhập"}
          </SoftButton>
        </SoftBox>
      </SoftBox>
    </IllustrationLayout>
  );
}

export default Illustration;
